export default {
  /**app名称**/
  APP_NAME:'Vay Sớm',

  /**设置语言，运营商认证，通过语言判断，泰国和越南运营商使用的不同方法，越南-》VN  泰国-》TH   **/
  DEF_LANGS:'VN',

  /**区号   VN=>+84    TH=>66**/
  COUNTRY_CODE:'+84',

  /**全局颜色**/
  GLO_COLOR:'#5acecd',

  /**全局货币符号   越南 => VND   泰国 =>THB**/
  GLO_COIN:'VND',

  /**版本号 **/
  VERSION:'V1.1.4',

  /**接口地址**/
  PORT_ADDRESS:'https://api2.vaysom.com/',

  /**借款页面，是否是固定额度
   *   GU =>展示固定额度
   *   jk =>展示接口过来的额度
   **/
  BORROW_LOAN_A:'jk'
};



//////////////////
// WEBPACK FOOTER
// ./static/utils/Common.js
// module id = u28r
// module chunks = 1